export const SET_SELECTED_PARAMETERS = "SET_SELECTED_PARAMETERS"